import React, { useEffect, useState } from "react";
//import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import logout, { isNativeLogoutInProgress } from "common/functions/logout";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Button from "../../common/components/CustomButtons/Button";
import redirect from "../../common/functions/redirect";
import { isIosDevice } from "../../deviceInfo";
//import withStyles from "@material-ui/core/styles/withStyles";

//import SweetAlert from "react-bootstrap-sweetalert";

function Logout(props) {
  const [ios, setIos] = useState(false);

  useEffect(() => {
    // Clearing account state can remount this route before navigation completes.
    if (isNativeLogoutInProgress()) return;
    isIosDevice()
      .then((isit) => setIos(isit))
      .catch((e) => null);
    if (window.confirm("Do you really want to logout?")) {
      logout();
    } else {
      props.history.goBack();
    }
  }, [props.history]);

  if (!ios) {
    return null;
  }
  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <h3>Logout</h3>
          <Button
            key="loginbutton"
            fullWidth
            onClick={() => {
              redirect();
            }}
            color="primaryLightBlue"
          >
            Login
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withRouter(Logout);
